{
  "role": {
    "sales_agent": "Sales agent",
    "sales_admin": "Sales administrator",
    "main": "Standard",
    "limited": "Limited"
  },
  "sales_agent": "{count, plural, =0 {no Sales agents} =1 {1 Sales agent} other {{count} Sales agents}}"
}
